import {
  CurrencyDollarIcon,
  DocumentTextIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  CalendarIcon,
  IdentificationIcon,
  MapPinIcon,
  ArrowTrendingUpIcon,
  LockClosedIcon,
  ExclamationTriangleIcon,
  Squares2X2Icon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';

export const sectionNavigation = [
  { id: 'required', label: 'Required Info' },
  { id: 'structure', label: 'Loan Structure' },
  { id: 'interest', label: 'Interest Terms' },
  { id: 'metrics', label: 'Property Metrics' },
  { id: 'dates', label: 'Key Dates' },
  { id: 'status', label: 'Loan Status' },
  { id: 'locations', label: 'Property Locations' },
  { id: 'stepup', label: 'Step-Up Terms' },
  { id: 'prepay', label: 'Prepayment Terms' },
  { id: 'forbearance', label: 'Forbearance' },
  { id: 'schedules', label: 'Schedules' },
  { id: 'advanced', label: 'Advanced' },
];

export const sectionIcons = {
  required: DocumentTextIcon,
  general: CurrencyDollarIcon,
  risk: ChartBarIcon,
  structure: Cog6ToothIcon,
  interest: CurrencyDollarIcon,
  metrics: ChartBarIcon,
  dates: CalendarIcon,
  status: IdentificationIcon,
  locations: MapPinIcon,
  stepup: ArrowTrendingUpIcon,
  prepay: LockClosedIcon,
  forbearance: ExclamationTriangleIcon,
  schedules: Squares2X2Icon,
  advanced: InformationCircleIcon,
};
